import { RouteObject } from "react-router-dom";

export interface RouteHandle {
  title?: string;
  breadcrumb?: string;
  showSidebar?: boolean;
}

export const getRouteHandle: (route: RouteObject) => RouteHandle | undefined = (
  route,
) => route.handle;
